import { render, staticRenderFns } from "./InspectionFourthStep.vue?vue&type=template&id=3d8f5b03&"
import script from "./InspectionFourthStep.vue?vue&type=script&lang=ts&"
export * from "./InspectionFourthStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports